import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { Menu } from '@headlessui/react';
import { Float } from '@headlessui-float/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MenuSelector = function MenuSelector(_ref) {
  var _priorityOptions, _menuOptions;

  var options = _ref.options,
      menuButtonStyles = _ref.menuButtonStyles,
      menuDialogStyles = _ref.menuDialogStyles,
      menuItemStyles = _ref.menuItemStyles,
      onSelect = _ref.onSelect,
      selectedLabel = _ref.selectedLabel,
      priorityItems = _ref.priorityItems,
      background = _ref.background,
      disabled = _ref.disabled,
      testIds = _ref.testIds;
  var menuOptions = options;
  var priorityOptions = [];

  if (priorityItems) {
    var priorityItemSet = new Set(priorityItems);
    menuOptions = options.filter(function (option) {
      return !priorityItemSet.has(option.value);
    });
    var newPriorityOptions = [];
    priorityItems.forEach(function (item) {
      var option = options.find(function (option) {
        return option.value === item;
      });

      if (option) {
        newPriorityOptions.push(option);
      }
    });
    priorityOptions = newPriorityOptions;
  }

  var upIcon = useMemo(function () {
    return background === 'white' ? /*#__PURE__*/_jsx(_StyledChevronUpIcon, {}) : /*#__PURE__*/_jsx(_StyledChevronUpIcon2, {});
  }, [background]);
  var downIcon = useMemo(function () {
    return /*#__PURE__*/_jsx(_StyledChevronDownIcon, {});
  }, []);
  return /*#__PURE__*/_jsx(Menu, {
    children: /*#__PURE__*/_jsxs(Float, {
      placement: "bottom-start",
      flip: true,
      zIndex: 900,
      transform: true,
      portal: true,
      offset: 6,
      children: [/*#__PURE__*/_jsx(StyledMenuButton, {
        $menuButtonStyles: menuButtonStyles,
        disabled: disabled,
        "data-cy": testIds === null || testIds === void 0 ? void 0 : testIds.dropdownBtn,
        children: function children(_ref2) {
          var open = _ref2.open;
          return /*#__PURE__*/_jsxs("div", {
            className: "flex flex-row items-center gap-2",
            children: [!selectedLabel ? /*#__PURE__*/_jsx("span", {
              children: "Select"
            }) : selectedLabel, open ? upIcon : downIcon]
          });
        }
      }), /*#__PURE__*/_jsxs(StyledMenuItems, {
        menuDialogStyles: menuDialogStyles,
        "static": true,
        "data-cy": testIds === null || testIds === void 0 ? void 0 : testIds.dropdownOptions,
        children: [priorityOptions.length > 0 && /*#__PURE__*/_jsx(StyledPriorityMenuContainer, {
          children: (_priorityOptions = priorityOptions) === null || _priorityOptions === void 0 ? void 0 : _priorityOptions.map(function (_ref3, index) {
            var label = _ref3.label,
                value = _ref3.value;
            return /*#__PURE__*/_jsx(Menu.Item, {
              children: function children(_ref4) {
                var close = _ref4.close;
                return /*#__PURE__*/_jsx(StyledMenuItemContainer, {
                  menuItemStyles: menuItemStyles,
                  onClick: function onClick() {
                    close();
                    onSelect(value);
                  },
                  children: label
                });
              }
            }, index);
          })
        }), /*#__PURE__*/_jsx(StyledMenuContainer, {
          children: (_menuOptions = menuOptions) === null || _menuOptions === void 0 ? void 0 : _menuOptions.map(function (_ref5, index) {
            var label = _ref5.label,
                value = _ref5.value;
            return /*#__PURE__*/_jsx(Menu.Item, {
              children: function children(_ref6) {
                var close = _ref6.close;
                return /*#__PURE__*/_jsx(StyledMenuItemContainer, {
                  menuItemStyles: menuItemStyles,
                  onClick: function onClick() {
                    close();
                    onSelect(value);
                  },
                  children: label
                });
              }
            }, index);
          })
        })]
      })]
    })
  });
};

var StyledMenuButton = /*#__PURE__*/_styled(Menu.Button).withConfig({
  displayName: "menu-selector__StyledMenuButton",
  componentId: "sc-17q7kns-0"
})(function (_ref7) {
  var $menuButtonStyles = _ref7.$menuButtonStyles;
  return [{
    "boxSizing": "border-box",
    "display": "flex",
    "whiteSpace": "nowrap",
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "paddingTop": "0.75rem",
    "paddingBottom": "0.75rem",
    "fontSize": "1rem",
    "lineHeight": "1.25rem",
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))"
  }].concat(_toConsumableArray($menuButtonStyles || []));
});

var StyledMenuItems = /*#__PURE__*/_styled(Menu.Items).withConfig({
  displayName: "menu-selector__StyledMenuItems",
  componentId: "sc-17q7kns-1"
})(function (_ref8) {
  var menuDialogStyles = _ref8.menuDialogStyles;
  return [{
    "display": "flex",
    "width": "auto",
    "flexDirection": "column",
    "gap": "0px",
    "borderRadius": "0.5rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "paddingRight": "0.563rem"
  }].concat(_toConsumableArray(menuDialogStyles || []));
});

var StyledMenuContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "menu-selector__StyledMenuContainer",
  componentId: "sc-17q7kns-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.75rem",
  "padding": "1rem"
});

var StyledPriorityMenuContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "menu-selector__StyledPriorityMenuContainer",
  componentId: "sc-17q7kns-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.75rem",
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
  "padding": "1rem"
});

var StyledMenuItemContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "menu-selector__StyledMenuItemContainer",
  componentId: "sc-17q7kns-4"
})(function (_ref9) {
  var menuItemStyles = _ref9.menuItemStyles;
  return [{
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "fontSize": "0.875rem",
    "lineHeight": "1.313rem",
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))",
    ":hover": {
      "cursor": "pointer"
    }
  }].concat(_toConsumableArray(menuItemStyles || []));
});

var _StyledChevronUpIcon = /*#__PURE__*/_styled(ChevronUpIcon).withConfig({
  displayName: "menu-selector___StyledChevronUpIcon",
  componentId: "sc-17q7kns-5"
})({
  "height": "1.25rem",
  "width": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))"
});

var _StyledChevronUpIcon2 = /*#__PURE__*/_styled(ChevronUpIcon).withConfig({
  displayName: "menu-selector___StyledChevronUpIcon2",
  componentId: "sc-17q7kns-6"
})({
  "height": "1.25rem",
  "width": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});

var _StyledChevronDownIcon = /*#__PURE__*/_styled(ChevronDownIcon).withConfig({
  displayName: "menu-selector___StyledChevronDownIcon",
  componentId: "sc-17q7kns-7"
})({
  "height": "1.25rem",
  "width": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))"
});